import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField } from '@material-ui/core';
import { ADD, EDIT, VIEW } from '../../../../common/common';

const Root = styled(Box)({
    width: '100%',
    padding: '0 10px',
    '& .textFieldF': {
        width: '100%',
        backgroundColor: '#FFFFFF',
    },
    '& .textTitle': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
})

class InputDO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            note: "",
            btnName: this.btnName(this.props.state)
        }
        this.handleChange = this.handleChange.bind(this);
    }
    render() {
        const { name, note } = this.state;
        return (
            <Root>
                <div className="textTitle">Document Name</div>
                <TextField
                    disabled={this.isDisabled()}
                    className="textFieldF"
                    value={name}
                    onChange={e => this.handleChange(e, 'name')}
                    margin="dense"
                    variant="outlined"
                />
                <div className="textTitle">Document Note</div>
                <TextField
                    disabled={this.isDisabled()}
                    className="textFieldF"
                    multiline
                    rows="3"
                    value={note}
                    onChange={e => this.handleChange(e, 'note')}
                    margin="dense"
                    variant="outlined"
                />
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    componentDidUpdate(prevProps) {
        console.log(this.props.name)
        if (this.props.name !== prevProps.name || this.props.note !== prevProps.note) {
            const name = this.props.name;
            const note = this.props.note;
            this.setState(() => ({
                name,
                note,
            }));
        }
    }
    initData() {
        const { name, note } = this.props;
        if (!name || !note) return;
        this.setState(() => ({
            name,
            note,
        }))
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
        this.props.setToDoc(name, value)
    }
    doNext() {
        const { name, note } = this.state;
        if (!name || !note) return false;
        return true;
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default InputDO;